import React, { useEffect, useState } from "react";
import { Table } from "antd";
import SearchBar from "../Main/searchBar";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { getProjectList } from "../../Redux/Actions/franchiseAction";
import { setSelection } from "../../Redux/Reducers/franchiseReducer"; // Adjust path
import "./projectList.css";

const ProjectCatalogueList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Read builderId, franchiseId, brandName from Redux instead of location.state
  const {
    selectedBuilderId: builderId,
    selectedFranchiseId: franchiseId,
    selectedBrandName: brandName, // add this to your reducer if needed
  } = useSelector((state) => state.franchises);

  const {
    projects = [],
    projectTotal = 0,
    loading,
  } = useSelector((state) => state.franchises || {});

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const cleanProjectData = (projects) => {
    if (!Array.isArray(projects)) {
      return [];
    }
    return projects.map((p) => ({
      key: p._id || p.id,
      _id: p._id || p.id,
      project_id: p.project_id || p.id,
      project_name: p.project_name || p.name,
      created_at: p.created_at,
    }));
  };

  const fetchProjectList = (page, pageSize) => {
    if (!builderId) {
      toast.error("Builder ID is missing");
      return;
    }

    const payload = {
      builder_id: builderId,
      status: ["approved", "published", "unpublished", "sold", "requested"],
      page,
      limit: pageSize,
      is_deleted: false,
    };

    dispatch(getProjectList(payload)).catch(() => {
      toast.error("Failed to fetch projects");
    });
  };

  useEffect(() => {
    if (builderId) {
      fetchProjectList(pagination.current, pagination.pageSize);
    }
  }, [builderId, pagination.current, pagination.pageSize]);

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      total: projectTotal || 0,
    }));
  }, [projectTotal]);

  const handleTableChange = (pagination) => {
    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
      total: pagination.total || pagination.total,
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "No Data";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Added new handler to dispatch and navigate without location.state usage
  const handleAssignProject = (record) => {
    dispatch(
      setSelection({
        builderId,
        franchiseId,
        projectId: record._id,
        projectName: record.project_name,
        brandName, // if used
      })
    );
    navigate("/franchise/form-assign-project");
  };

  const columns = [
    {
      title: "No.",
      dataIndex: "key",
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 60,
      align: "center",
    },
    {
      title: "Project ID",
      dataIndex: "project_id",
      key: "project_id",
      width: 150,
      render: (text) => text || "No Data",
      align: "center",
    },
    {
      title: "Project Name",
      dataIndex: "project_name",
      key: "project_name",
      render: (text) => text || "No Data",
      width: 150,
      align: "center",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (text) => formatDate(text),
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      align: "center",
      render: (_, record) => (
        <button onClick={() => handleAssignProject(record)}>Assign Project</button>
      ),
    },
  ];

  return (
    <div className="grid-container">
      <div
        className="padding-20"
        style={{ gridColumn: "3/8", marginBottom: 20 }}
      >
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div className="back-icon-container">
        <div className="back-icon-left">
          <Link to="/franchise">
            <BackIcon style={{ cursor: "pointer", width: 80, height: 80 }} />
          </Link>
          <h3 style={{ margin: 0, fontWeight: 600, color: "#181E2E" }}>
            Projects List
          </h3>
        </div>

        <Link to={`/franchise/assign_projects`} className="assign-builder-link">
          Assign Project List
        </Link>
      </div>

      <div className="overall-container">
        <div
          className="Projectss-list-wrapper"
          style={{ backgroundColor: "#f3f3f3", padding: "0px 60px" }}
        >
          <Table
            columns={columns}
            dataSource={cleanProjectData(projects)}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "15", "20"],
            }}
            onChange={handleTableChange}
            rowKey="key"
            locale={{ emptyText: "No projects found." }}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectCatalogueList;
